import camelcaseKeysDeep from 'camelcase-keys-deep'
import * as R from 'ramda'
import { ModuleNames } from '@/store/module-names'
import { ExerciseProgramState, FlatExerciseProgram } from './types'
import { getters } from './getters'
import { ActionNames, MutationNames } from './keys'
import {
  getExerciseProgramQuery,
  postExerciseProgramQuery,
  PostExerciseProgramPayload,
  patchExerciseProgramQuery,
  deleteExerciseProgramQuery,
} from '@/jsonapi/ExerciseProgram'
import {
  getExerciseProgramSessionQuery,
  patchExerciseProgramSessionQuery,
  PostExerciseProgramSessionPayload,
  postExerciseProgramSessionQuery,
  deleteExerciseProgramSessionQuery,
} from '@/jsonapi/ExerciseProgramSession'
import { findRemoteIdFromNewRecord } from '@/http/utils'

const state: ExerciseProgramState = {
  chosenExerciseProgramId: null,
  exercisePrograms: [],
  exerciseProgramSessions: [],
}

const mutations = {
  [MutationNames.updateExercisePrograms](state, payload): void {
    state.exercisePrograms = payload
  },
  [MutationNames.updateChosenExerciseProgramId](state, payload: string): void {
    state.chosenExerciseProgramId = payload
  },
  [MutationNames.pushNewExerciseProgram](state, payload): void {
    state.exercisePrograms.push(payload)
  },
  [MutationNames.updateExerciseProgramSessions](state, payload): void {
    state.exerciseProgramSessions = payload
  },
}

const actions = {
  async [ActionNames.getExercisePrograms]({ commit }): Promise<void> {
    const results = camelcaseKeysDeep(await getExerciseProgramQuery())
    commit(MutationNames.updateExercisePrograms, results)
  },

  async [ActionNames.getExerciseProgramSessions]({ commit }): Promise<void> {
    const results = camelcaseKeysDeep(await getExerciseProgramSessionQuery())
    commit(MutationNames.updateExerciseProgramSessions, results)
  },

  [ActionNames.setChosenExerciseProgramId]({ commit }, programId: string) {
    commit(MutationNames.updateChosenExerciseProgramId, programId)
  },

  async [ActionNames.postExerciseProgram]({ commit }, payload: PostExerciseProgramPayload) {
    const newExerciseProgramId = await postExerciseProgramQuery(payload)
    const results = camelcaseKeysDeep(await getExerciseProgramQuery())
    commit(MutationNames.updateExercisePrograms, results)
    commit(MutationNames.updateChosenExerciseProgramId, newExerciseProgramId)
  },

  async [ActionNames.patchExerciseProgram]({ commit }, payload) {
    await patchExerciseProgramQuery(payload)
    const results = camelcaseKeysDeep(await getExerciseProgramQuery())
    commit(MutationNames.updateExercisePrograms, results)
  },

  async [ActionNames.deleteExerciseProgram]({ commit }, payload) {
    await deleteExerciseProgramQuery(payload)
    const results = camelcaseKeysDeep(await getExerciseProgramQuery())
    commit(MutationNames.updateExercisePrograms, results)
  },

  async [ActionNames.postExerciseProgramSession]({ commit }, payload: PostExerciseProgramSessionPayload) {
    const newExerciseSessionId = await postExerciseProgramSessionQuery(payload)
    const results = camelcaseKeysDeep(await getExerciseProgramQuery())
    commit(MutationNames.updateExercisePrograms, results)
    console.log(newExerciseSessionId)
    return newExerciseSessionId
  },

  async [ActionNames.patchExerciseProgramSession]({ commit }, payload) {
    await patchExerciseProgramSessionQuery(payload)
    const results = camelcaseKeysDeep(await getExerciseProgramQuery())
    commit(MutationNames.updateExercisePrograms, results)
  },

  async [ActionNames.deleteExerciseProgramSession]({ commit }, payload) {
    await deleteExerciseProgramSessionQuery(payload)
    const results = camelcaseKeysDeep(await getExerciseProgramQuery())
    commit(MutationNames.updateExercisePrograms, results)
  },
}

export default {
  name: ModuleNames.exerciseProgram,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
